import { JoinRoomRequest } from '@ftr/contracts/socket/join-room/JoinRoomRequest'
import { Uuid } from '@ftr/contracts/type/shared'

// This joins the unauthenticated socket room for the recording
export function getPublicRecordingSocketRoomId(recordingId: Uuid): JoinRoomRequest {
  return { roomId: `recording:${recordingId}` }
}
